import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const VerticalDividerIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M10 4L10 16" stroke={COLORS.black10} strokeLinecap="round" />
  </svg>
);

VerticalDividerIcon.propTypes = { className: PropTypes.string };

export default VerticalDividerIcon;
